import {
  ChakraGridItem,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  Menu,
  MenuOption,
  UpDownArrow,
} from '@equip.health/ui';

import { GridItemProps } from '../../constants';

const { primary } = EquipUIFireflyV2Theme.colors;
const { paragraph } = EquipUITheme.typography;

enum Position {
  STANDING = 'Standing',
  SITTING = 'Sitting',
  LYING_DOWN = 'Lying down',
  UNKNOWN = 'Unknown',
}

const positionOptions: MenuOption[] = [
  Position.STANDING,
  Position.SITTING,
  Position.LYING_DOWN,
  Position.UNKNOWN,
].map((position: string) => ({ node: position, value: position }));

const PositionGridItem = ({
  colSpan,
  id,
  isEditing,
  onChange,
  value,
}: GridItemProps<string>) => (
  <ChakraGridItem colSpan={colSpan} id={`${id}__position-item`}>
    {isEditing ? (
      <Menu
        buttonContent={value}
        buttonSize="sm"
        icon={<UpDownArrow fill={primary[100]} height="15px" width="12px" />}
        id={`${id}__position`}
        isFullWidth
        onSelect={onChange}
        options={positionOptions}
        placeholder="Select..."
        textAlign="left"
      />
    ) : (
      value && (
        <ChakraText {...paragraph} id={`${id}__position`}>
          {value}
        </ChakraText>
      )
    )}
  </ChakraGridItem>
);

export default PositionGridItem;
